import { render, staticRenderFns } from "./WishButton.vue?vue&type=template&id=289869fa"
import script from "./WishButton.vue?vue&type=script&lang=js"
export * from "./WishButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports